import wx from 'weixin-js-sdk';
import axios from 'axios';

/*
 * @Author: Qzx
 * @Date: 2018-10-12 16:58:57
 * @LastEditors: Qzx
 * @LastEditTime: 2020-04-08 17:01:58
 * @Description: app原生分享与微信分享整合
 */
window.wx = wx;
class XesShare {
    constructor(parmas = {}) {
        let { wxShareUrl, jsApiList, debug } = parmas; // 分享初始定义参数
        this.wxShareUrl = wxShareUrl || 'https://weixin.xueersi.com/Share/conf'; // 获取微信配置接口
        this.jsApiList = jsApiList || [
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'hideMenuItems',
            'getNetworkType'
        ]; // 需要使用的微信 JS接口列表
        this.wxDebug = debug || false;
        this.shareClient = 0;
        this.wxUpdateStatus = false; // 当前微信客户端是否支持最新分享api
        // 获取网页当前所处的环境  1、微信、2、原生app、0、其他浏览器
        this.getClient();
        this.init();
    }
    init() {
        if (this.shareClient == 1) {
            axios.post(this.wxShareUrl).then((res) => {
                if (res.data.sign == 1) {
                    let _config = res.data.msg.wxConf;
                    let _debug = this.wxDebug && process.env.NODE_ENV == 'development';
                    wx.config({
                        debug: _debug,
                        appId: _config.appId,
                        timestamp: _config.timeStamp,
                        nonceStr: _config.nonceStr,
                        signature: _config.signature,
                        jsApiList: this.jsApiList // 必填，需要使用的JS接口列表
                    });
                    // 判断当前客户端版本是否支持指定JS接口
                    let _this = this;
                    wx.checkJsApi({
                        jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
                        success: function (res) {
                            // 以键值对的形式返回，可用的api值true，不可用为false
                            let result = typeof res.checkResult === "string" ? JSON.parse(res.checkResult) : res.checkResult;
                            if (result.updateAppMessageShareData && result.updateTimelineShareData) {
                                _this.wxUpdateStatus = true;
                            }
                        }
                    });
                }
            });
            // config信息验证失败会执行error函数。
            wx.error(function (res) {
                console.log(res, '微信分享配置错误');
            });
        }
    }
    /**
     * 获取网页当前所处的环境  1、微信、2、原生app、0、其他浏览器
     */
    getClient() {
        let _ua = navigator.userAgent.toLowerCase();
        // if (_ua.match(/MicroMessenger/i) == 'micromessenger') {
        if (_ua.match(/MicroMessenger/i) !== null) {
            this.shareClient = 1; // 微信环境
        }
        else if (/jzh$/.test(_ua)) {
            this.shareClient = 2; // 学而思网校app
        }
    }
    /**
     * 调起分享大图模式
     * @param {*} parmas      分享的参数
     * @param {*} successFun  分享成功的回调方法
     * @param {*} cancelFun   分享失败的回调方法
     */
    shareImg(parmas = {}, successFun) {
        // 学而思网校app内嵌 webView 环境
        if (this.shareClient == 2) {
            let appShareConfig = {
                shareType: 2,
                imagePath: parmas.imgUrl || '',
                shareScence: 63,
                businessId: 2018,
                agentKey: '',
                isOneKeyShare: false // 是否一键分享
            };
            Object.assign(appShareConfig, parmas);
            window.xesApp.appShareBack = successFun;
            window.xesApp.start('xesShare/share', JSON.stringify(appShareConfig), 'xesApp.appShareBack');
        }
        else {
            // 普通浏览器环境
            console.log('显示图片弹框');
        }
    }
    /**
     * 调起分享链接模式
     * @param {*} parmas      分享的参数
     * @param {*} successFun  分享成功的回调方法
     * @param {*} cancelFun   分享失败的回调方法
     */
    shareLink(parmas = {}, successFun, cancelFun) {
        // 微信浏览器环境分享
        if (this.shareClient == 1) {
            let _this = this;
            wx.ready(function () {
                let wxShareConfig = {
                    title: parmas.title || document.title,
                    desc: parmas.desc || '',
                    link: parmas.link || window.location.href,
                    imgUrl: parmas.imgUrl ||
                        'https://activity.xueersi.com/topic/growth/common/images/common/xes-logo.png' // 分享图标
                };
                if (!_this.wxUpdateStatus) {
                    // 用户点击了分享后执行的回调函数
                    wxShareConfig.success = function (res) {
                        typeof successFun === 'function' && successFun(res);
                    };
                    // 用户取消分享后执行的回调函数
                    wxShareConfig.cancel = function (res) {
                        typeof cancelFun === 'function' && cancelFun(res);
                    };
                    wx.onMenuShareTimeline(wxShareConfig); // 分享给到朋友圈
                    wx.onMenuShareAppMessage(wxShareConfig); // 分享给朋友
                    wx.onMenuShareQQ(wxShareConfig); // 分享到QQ
                    wx.onMenuShareQZone(wxShareConfig); // 分享QQ空间
                    wx.onMenuShareWeibo(wxShareConfig); // 分享到微博
                }
                else {
                    wx.updateAppMessageShareData(wxShareConfig);
                    wx.updateTimelineShareData(wxShareConfig);
                }
            });
        }
        else if (this.shareClient == 2) {
            // 学而思网校app原生分享
            console.log('学而思网校app暂不支持分享内容设置');
        }
        else {
            console.log('当前浏览器不支持分享，请在微信里面打开');
        }
    }
    /**
     * 调起分享链接模式
     * @param {*} parmas      分享的参数
     * @param {*} successFun  分享成功的回调方法
     * @param {*} cancelFun   分享失败的回调方法
     */
    shareAppLink(parmas = {}, successFun, cancelFun) {
        // 学而思网校app原生分享
        let appShareConfig = {
            shareType: 1,
            title: document.title,
            description: parmas.desc || '',
            actionUrl: parmas.link || '',
            shareScence: 31,
            businessId: 2018,
            agentKey: '',
            isOneKeyShare: false // 是否一键分享
        };
        Object.assign(appShareConfig, parmas);
        window.xesApp.appShareBack = successFun;
        window.xesApp.start('xesShare/share', JSON.stringify(appShareConfig), 'xesApp.appShareBack');
    }
    /**
     * 隐藏微信右上角的分享按钮
     * 隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
     */
    shareHide(parmasArr = []) {
        if (this.shareClient == 1) {
            wx.ready(function () {
                wx.hideMenuItems({
                    menuList: parmasArr
                });
            });
        }
        else if (this.shareClient == 2) {
            window.xesApp && window.xesApp.setTitleMenu(0);
        }
    }
    /**
     * 获取网络状态接口
     * @return {*} 返回网络类型 2g，3g，4g，wifi
     */
    getNetworkType() {
        if (this.shareClient == 1) {
            return new Promise(resolve => {
                wx.ready(function () {
                    wx.getNetworkType({
                        success: function (res) {
                            resolve(res);
                        }
                    });
                });
            });
        }
    }
}

export default XesShare;
